import {
  patientsDocumentsSelectors,
  patientsDocumentsConfig,
  queryPatientsDocuments,
  postprocessPatientsDocuments,
  validatePatientsDocuments,
} from "../../common1/firebase-selectors/patients-documents";
import renderSingleItemForm from "./renderSingleItemForm";
import { savePatients } from "../../common1/firebase-selectors/patients";
import { getFirebaseApp } from "../../components/DynamicFormWithFiles";

const ConfigSingle = (patient) => {
  const pSelectors = patientsDocumentsSelectors(patient);
  const firebaseStorage = getFirebaseApp().storage();

  return {
    primaryKey: patientsDocumentsConfig.primaryKey,

    disableEditPrimaryKey: true,

    initialQueries: [queryPatientsDocuments(patient)],

    sessionKey: `careapp.patients.sitting${patient}`,
    noItemMsg: "No Documents Available",
    mainTitle: "Documents ",

    singleItemSelector: pSelectors.id,
    singleItemDispatcher: null,

    collection: patientsDocumentsConfig.collection(patient),
    postprocess: postprocessPatientsDocuments,
    validate: validatePatientsDocuments,
    formFields: patientsDocumentsConfig.fields,
    formDefaults: patientsDocumentsConfig.defaults,

    postSave: ({ dbStore }) => {
      dbStore
        .get(patientsDocumentsConfig.collection(patient), "documents")
        .then((doc) => {
          if (doc.exists) {
            const num_docs =
              "documents" in doc.data() ? doc.data().documents.length : 0;
            savePatients(dbStore, patient, { num_docs });
          }
        });
    },

    storageNameSpace: {
      firebaseStorage,
      namespace: `patient-records/${patient}`,
    },
    renderSingleItemForm,
  };
};

export default ConfigSingle;
